<div class="shop-card-container">
  <div class="image-wrapper">
    <img
      class="shop-card-image"
      loading="lazy"
      [src]="profilePicture"
      [alt]="data.fotoFile"
      (error)="updateErrorUrl()"
    />
  </div>
  <div class="shop-card-data">
    <span class="name" [class]="{ 'cursor-pointer': data.nicknev }" (click)="onClickShop()">{{ data.boltNeve }}</span>
    <span class="address"
      >{{ data.iranyitoszam }}, {{ data.telepules }}, {{ data.cim }} <br />
      {{ data.cimKiegeszites }}</span
    >
    <span class="clickable-data" (click)="navigate('tel:' + data.telefonszam)">{{ data.telefonszam }}</span>
  </div>
</div>
